export class ReportefallaEntity {
    constructor() {
    }

    public reportefalla_id: string | null = null;
    public trabajador_id: string | null = null;
    public empresa_id: string | null = null;
    public computadora_id: string | null = null;
    public telefono_id: string | null = null;
    public reportefalla_tipoequipo: string | null = null;
    public reportefalla_fecha: string | null = null;
    public reportefalla_sede: string | null = null;
    public reportefalla_serie: string | null = null;
    public reportefalla_descripcionequipo: string | null = null;
    public reportefalla_usuario: string | null = null;
    public reportefalla_descripcionfalla: string | null = null;
    public reportefalla_actividadrealizada: string | null = null;
    public reportefalla_responsable: string | null = null;
    public reportefalla_fechaatencion: string | null = null;
    public reportefalla_estado: string | null = null;

    public toString(): string | null {
        return this.reportefalla_id;
    }
}
